import React, { useEffect, useState } from 'react';
import { Card, Form } from 'antd';
import dayjs from 'dayjs';

import Headline from '../../../UI/Headline/Headline';
import TrailForm from '../TrailForm/TrailForm';
import { trailTimeFormat } from '../../../../consts/dates';
import TrailService from '../../../../Services/api/TrailService';
// import Notifications from '../../../../Services/Notifications/Notifications';

function EditTrail({ companyId, trailId }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);

    const initializeData = (trailData) => {
        const data = trailData;

        data.startTime = dayjs(data.startTime, trailTimeFormat);
        data.endTime = dayjs(data.endTime, trailTimeFormat);
        data.tags = data.tags?.split(',') || [];
        data.placeId = data.place.id;

        const startCoords = data.startCoordinates?.split('/');
        if (startCoords) {
            data.startCoordinatesLat = startCoords[0];
            data.startCoordinatesLng = startCoords[1];
        }

        const endCoords = data.endCoordinates?.split('/');
        if (endCoords) {
            data.endCoordinatesLat = endCoords[0];
            data.endCoordinatesLng = endCoords[1];
        }

        return data;
    };

    useEffect(() => {
        const fetchTrail = async () => {
            const trailData = await TrailService.findOne(trailId);
            form.setFieldsValue(initializeData(trailData));
            setLoading(false);
        };

        fetchTrail();
        // eslint-disable-next-line
    }, []);

    const editTrailHandler = async (trail) => {
        setLoading(true);
        const payload = { ...trail, companyId: Number(companyId) };
        try {
            await TrailService.update(trailId, payload);
            // Notifications.success('Zapisano');
            window.location.href = '/admin/routes';
        } catch (err) {
            console.log('error');
            alert('Coś poszło nie tak');
        }
        setLoading(false);
    };

    return (
        <Card bordered>
            <Headline title="Edytuj trasę" />
            <TrailForm
                form={form}
                loading={loading}
                successHandler={editTrailHandler}
                submitButtonText="Zapisz"
            />
        </Card>
    );
}

export default EditTrail;
